const CashInMethod = {
  Card: "card",
  OverTheCounter: "otc",
  OnlineBanking: "online-banking",
};

export default CashInMethod;
